<template>
  <v-app class="app">
    <v-main>
      <BaseAppNotifications />
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { setAuth, clearAuth } from '@/service/cookies';

import BaseAppNotifications from '@/components/BaseAppNotifications';

export default {
  name: 'App',
  components: { BaseAppNotifications },
  data() {
    return {
      activeState: null,
      notifications: 'true',
      isWorkspaceLoadingActive: true,
    };
  },
  computed: {
    ...mapGetters('stripe', ['get_payment_methods']),
    ...mapGetters('workspace', ['get_workspace']),
  },
  methods: {},
  async beforeMount() {
    if (this.get_user) {
      try {
        setAuth(this.$store.state.user);
      } catch (error) {
        clearAuth();
        this.$router.replace('/login');
      }
    }
  },
  mounted() {
    this.$store.watch(
      ({ workspace: { loading } }) => (this.isWorkspaceLoadingActive = loading)
    );
  },
  watch: {
    $route(to, from) {
      this.activeState = to.name.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
@import '@/assets/scss/animation.scss';

.app {
  background: #f5f6fa !important;
}
</style>
